

import axiosClient from '../axiosClient';

export const salesCogsApi = {
    getSalesCogsData: async (financialYear, filters = {}) => {
        try {
            const params = new URLSearchParams({ financialYear });

            // Send each selected value as a separate param with the same key
            // e.g. category=1&category=2&category=3
            if (filters.customer) {
                filters.customer.split(',').forEach(v => { if (v.trim()) params.append('customer', v.trim()); });
            }
            if (filters.category) {
                filters.category.split(',').forEach(v => { if (v.trim()) params.append('category', v.trim()); });
            }
            if (filters.salesEmployee) {
                filters.salesEmployee.split(',').forEach(v => { if (v.trim()) params.append('salesEmployee', v.trim()); });
            }
            if (filters.contactPerson) {
                filters.contactPerson.split(',').forEach(v => { if (v.trim()) params.append('contactPerson', v.trim()); });
            }
            if (filters.itemCode) {
                filters.itemCode.split(',').forEach(v => { if (v.trim()) params.append('itemCode', v.trim()); });
            }

            console.log('📊 Fetching Sales vs COGS | FY:', financialYear, '| Filters:', filters);
            console.log('📊 Params string:', params.toString());

            const data = await axiosClient.get(`/sales-cogs?${params.toString()}`);
            return data;
        } catch (error) {
            console.error('Error fetching Sales vs COGS data:', error);
            throw error;
        }
    }
};